<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <div class="unoutboundCount">
            <!-- Export (F.D) 单独一个权限位，all_query 没有（release-sql/all_query_outbound_export_fd.sql） -->
            <a-button class="form_btn" type="primary" size="mini" v-permission="'setting.stock.exportShipmentFD'" :disabled="exporting" @click="handle('exportFile')">
                <icon-download size="13" style="marginRight:5px;"/>
                {{ $t('stock.exportShipment2') }}
            </a-button>
            <a-button v-permission="'setting.stock.zuExportShipment'" class="form_btn" type="primary" size="mini" :disabled="exporting" @click="handle('zuExportFile')">
                <icon-download size="13" style="marginRight:5px;"/>
                {{ $t('stock.zuExportShipment') }}
            </a-button>
            <a-divider direction="vertical" v-permission="'setting.stock.exportShipmentFD'"/>
            <a-button class="form_btn" type="primary" size="mini" v-permission="'setting.stock.exportShipment'" :disabled="exporting" @click="handle('separateExport')">
                <icon-download size="13" style="marginRight:5px;"/>
                {{ $t('stock.exportShipment') }}
            </a-button>
            <a-divider direction="vertical" v-permission="'setting.stock.sendEmailToZU'"/>
            <a-button v-permission="'setting.stock.sendEmailToZU'" class="form_btn" type="primary" size="mini" :disabled="exporting" @click="handle('sendEmailToZU')">
                <icon-download size="13" style="marginRight:5px;"/>
                {{ $t('stock.sendEmailToZU') }}
            </a-button>
            <a-divider direction="vertical" />
            <a-alert class="countBar">
                <span>{{$t('stock.asOf')}}{{warningDate}} 00:00:00， {{$t('stock.bikeCount')}}：{{unoutboundCount.bike}}，</span>
                <span>{{$t('stock.bomCount')}}：{{unoutboundCount.bom}}</span>
            </a-alert>
        </div>

        <Table 
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @cellDblClick="cellDblClick"
        >
            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'order_name'">
                    <a-popover position="top"  trigger="click" v-if="userInfo.role != '6' && userInfo.role != '7'" @popup-visible-change="(val)=>popupVisibleChangeAmount(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;">{{ props.record.order_name }}</a-button>
                        <template #content>
                            <a-spin :loading="amountInfo_loading" tip="loading..." class="customer_info">
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderName') }}：</span>{{ amountInfo.order_name }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderAmount') }}：</span>{{ amountInfo.order_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.payAmount') }}：</span>{{ amountInfo.pay_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.realPayAmount') }}：</span>{{ amountInfo.real_pay_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderDiscount') }}：</span>{{ amountInfo.order_discount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.refundAmount') }}：</span>{{ amountInfo.refund_amount }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.orderTax') }}：</span>{{ amountInfo.order_tax }}</div>
                                <div><span style="display:inline-block;width:120px;">{{ $t('order.taxRate') }}：</span>{{ amountInfo.tax_rate }}</div>
                            </a-spin>
                        </template>
                    </a-popover>
                    <span v-if="userInfo.role == '6' || userInfo.role == '7'">{{ props.record.order_name }}</span>
                </div> 
                <div v-if="props.column.key == 'warehouse'">
                    <div>{{ props.record.warehouse }}</div>
                    <a-tooltip :content="props.record.warehouse_name">
                        <div style="font-size:11px;color:#666;overflow:hidden;text-overflow:ellipsis;cursor: pointer;">{{ props.record.warehouse_name }}</div>
                    </a-tooltip>
                    <!-- <a-popover position="top"  trigger="hover" @popup-visible-change="(val)=>getWarehouseDescription(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;">{{ props.record.warehouse }}</a-button>
                        <template #content>
                            <a-spin class="customer_info">
                                <div>{{ props.record.warehouse_description }}</div>
                            </a-spin>
                        </template>
                    </a-popover> -->
                </div>
                <div v-if="props.column.key == 'status'">
                    <a-tag :color="props.record.status_val == 1? 'red' : props.record.status_val == 2? 'green' : props.record.status_val == 3? 'orange' :  props.record.status_val == 4? 'blue' : props.record.status_val == 7? 'purple' : 'gray' ">{{ props.record.status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'order_channel_type'">
                    <a-tag :color="props.record.order_channel_type_val == 0? 'blue' : props.record.order_channel_type_val == 1? 'green' : props.record.order_channel_type_val == 2? 'yellow' : 'orange' ">{{ props.record.order_channel_type }}</a-tag>
                </div>
                <!-- <div v-if="props.column.key == 'transaction_date'">
                    <span style="color:#4080ff">{{ props.record.transaction_date }}</span>
                </div>
                <div v-if="props.column.key == 'delivery_date'">
                    <span style="color:#4080ff">{{ props.record.delivery_date }}</span>
                </div> -->
                
                <div v-if="props.column.key == 'model_model_year'">
                    <div v-if="props.record.model == '-' && props.record.model_year == '-'" style="font-size:12px">-</div>
                    <div v-else style="font-size:12px">{{ props.record.model }}，{{props.record.model_year}}</div>
                </div>
                <div v-if="props.column.key == 'brand_part_name'">
                    <div style="font-size:12px;color: #666;">{{ $t('stock.brandName') }}: {{ props.record.brand_name }}</div>
                    <div style="font-size:12px;color: #666;">{{ $t('stock.partName') }}: {{ props.record.part_name }}</div>
                </div>
                <div v-if="props.column.key == 'outbound_date'">
                    <div style="color:#4080ff">{{ $t('stock.plan') }}: {{ props.record.transaction_date }}</div>
                    <div style="color:#4080ff">{{ $t('stock.real') }}: {{ props.record.delivery_date }}</div>
                </div>
                <div v-if="props.column.key == 'create_date'">
                    <span style="color:#4080ff">{{ props.record.create_date }}</span>
                </div>
                <div v-if="props.column.key == 'sign_time'">
                    <span style="color:#4080ff">{{ props.record.sign_time }}</span>
                </div>

                <div v-if="props.column.key == 'quantity'" class="logisticsInfo">
                    <div>{{ $t('stock.orderQty') }}：{{ props.record.quantity }}</div>
                    <div>{{ $t('stock.shipQty') }}：{{ props.record.ship_qty }}</div>
                </div>

                <div v-if="props.column.key == 'logistics'" class="logisticsInfo">
                    <div>{{ $t('stock.logisticsType') }}：{{ props.record.courier_type }}</div>
                    <div>{{ $t('stock.logisticsNo') }}：{{ props.record.courier_no }}</div>
                    <div>{{ $t('stock.logisticsLink') }}：<span style="display：inline-block;white-space:wrap;">{{ props.record.courier_url }}</span></div>
                </div>

                <div v-if="props.column.key == 'frame_number' && userInfo.role != '8'" class="frameNumber">
                    <div class="frameNumberDiv">
                        <div v-if="props.record.frame_number_arr.length > 0 && props.record.frameNumberIsText" class="frameNumberTextParent">
                            <div v-for="(item,index) in props.record.frame_number_arr" :key="index" class="frameNumberText" :style="{'color':item.VEHICLE_STATUS == 1? 'red' : '#333'}">
                                {{ item.FRAME_NUMBER }}
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length > 0 && !props.record.frameNumberIsText" class="frameNumberInput">
                            <div v-for="(item,index) in props.record.frame_number_arr" :key="index" >
                                <a-input :style="{width:'140px',marginTop:'5px'}" v-model="props.record.frame_number_arr[index].FRAME_NUMBER" />
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length == 0 && !props.record.frameNumberIsText" class="frameNumberInput">
                            <a-input :style="{width:'140px',marginTop:'5px'}" v-model="props.record.frame_number_arr[0].FRAME_NUMBER" />
                        </div>
                        <div v-else-if="props.record.frame_number_arr.length == 0 && props.record.frameNumberIsText">-</div>
                    </div>
                    
                    <span class="iconBtn">
                        <icon-check v-if="!props.record.frameNumberIsText" @click="saveFrameNumber(props.record)" class="icon iconCheck" :style="{color:'green'}"/>
                        <icon-close v-if="!props.record.frameNumberIsText" @click="cancelSaveFrameNumber(props.record)" class="icon iconClose" :style="{color:'red'}"/>
                    </span>
                </div>

                <div v-if="props.column.key == 'po'" class="frameNumber">
                    <div class="frameNumberDiv">
                        <div v-if="props.record.frame_number.length > 0" class="frameNumberTextParent">
                            <div v-for="(item,index) in props.record.frame_number" :key="index" class="frameNumberText">
                                <span v-if="item.BOX_NO">{{ item.BOX_NO }}</span>   
                                <span v-else>-</span>   
                            </div>
                        </div>
                        <div v-else-if="props.record.frame_number.length == 0">-</div>
                    </div>
                </div>

                <div v-if="props.column.key == 'customer_name'" >
                    <a-popover position="top"  trigger="click" @popup-visible-change="(val)=>popupVisibleChange(val,props.record)">
                        <a-button type="text" style="text-wrap: wrap;text-align: left;">{{ props.record.customer_name }}</a-button>
                        <template #content>
                            <a-spin :loading="customerInfo_loading" tip="loading..." class="customer_info" >
                                <div class="edit_icon" v-if="userInfo.role != '6' && userInfo.role != '7' && !is_hepha_customer">
                                    <icon-edit :size="18" @click="editCustomer(customerInfo.customer_entity_id)"/>
                                </div>
                                <div style="display:inline-block;margin-right:15px;vertical-align: top;">
                                    <div><span style="font-weight:bold">{{ $t('customer.contactName3') }}：</span> {{ customerInfo.name }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.contactName2') }}：</span> {{ customerInfo.name2 }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerPhone') }}：</span> {{ customerInfo.phone }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.zip') }}：</span> {{ customerInfo.zip }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerCity') }}：</span> {{ customerInfo.city }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerCountry') }}：</span> {{ customerInfo.country }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerAddr') }}：</span> {{ customerInfo.address }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerAddr2') }}：</span> {{ customerInfo.address2 }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.billingAddress') }}：</span> {{ customerInfo.billing_address }}</div>
                                    <div><span style="font-weight:bold">{{ $t('customer.customerEmail') }}：</span> {{ customerInfo.email }}</div>
                                </div>
                            </a-spin>
                        </template>
                    </a-popover>
                </div>

                <div v-if="props.column.key == 'instruction' && userInfo.role != '8'" class="remark">
                    <a-tooltip :content="props.record.instruction">
                        <div class="remark_content" v-if="props.record.remarkIsText">{{ props.record.instruction }}</div>
                    </a-tooltip>
                    
                    <a-input v-if="!props.record.remarkIsText" :style="{width:'180px'}" v-model="props.record.instruction" />
                    <icon-check v-if="!props.record.remarkIsText" @click="saveComment(props.record)" :style="{display:'inline-block',marginLeft:'5px',color:'green',cursor:'pointer',fontWeight:'blod'}"/>
                    <icon-close v-if="!props.record.remarkIsText" @click="cancelSaveComment(props.record)" :style="{display:'inline-block',marginLeft:'10px',color:'red',cursor:'pointer',fontWeight:'blod'}"/>
                </div>
            </template>

            <template v-slot:tableOperate="{ props }">
                <!-- <a-button v-permission="'setting.stock.signFor'"  type="primary" size="mini" :disabled="props.record.status_val !== 2" style="width:72px" @click="handle('signFor',props.record)">{{ $t('stock.signFor') }}</a-button> -->
                <a-button v-permission="'setting.stock.edit'"  type="primary" size="mini" :disabled="props.record.status_val == 3" style="margin-top:5px;width:72px" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
                <a-popover position="left" style="width:350px" @popup-visible-change="(val)=>btnPopupVisibleChange(val,props.record)">
                    <a-button 
                        v-if="!is_hepha_customer"
                        type="primary" 
                        size="mini" 
                        style="margin-top: 2px;width: 72px;"
                    >
                        {{$t('base.more') }} <icon-more size="16" style="margin-left:5px;"/> 
                    </a-button>
                    <template #content>
                        <!-- 基础操作 -->
                        <!-- <a-divider orientation="center" v-permission="'setting.stock.detail'" style="font-weight:600">{{ $t('base.base') }}</a-divider> -->
                        <!-- <a-button v-permission="'setting.stock.edit'"  type="primary" size="mini" :disabled="props.record.status_val == 3" style="margin-top:5px;width:130px" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button> -->
                        <!-- <a-divider v-permission="'setting.stock.edit'" direction="vertical"></a-divider> -->
                        <a-button v-permission="'setting.stock.cancel'" type="primary" status="danger" size="mini" :disabled="props.record.status_val != 1 && props.record.status_val != 4 || props.record.warehouse == 'HFFG05'" style="margin-top:5px;width:130px" @click="handle('cancelOutbound',props.record)">{{ $t('stock.cancelOutbound') }}</a-button>
                        <a-divider v-permission="'setting.stock.cancel'" direction="vertical"></a-divider>
                        <a-button v-permission="'setting.stock.detail'" type="primary" size="mini" style="margin-top:5px;width:130px" @click="handle('addFrameNo',props.record)">{{ $t('stock.addFrameNo') }}</a-button>
                        <!-- <a-divider v-permission="'setting.stock.detail'" direction="vertical"></a-divider> -->
                        <a-button v-permission="'setting.stock.detail'" type="primary" size="mini" style="margin-top:5px;width:130px" @click="handle('detail',props.record)">{{ $t('base.detail') }}</a-button>
                        
                        <!-- 发货单：分隔线跟着按钮权限走，没有下载 / 发送权限（如 all_query）就整段不显示 -->
                        <a-divider v-if="userInfo.role != '6' && userInfo.role != '8' && (hasPermission('setting.stock.download') || hasPermission('setting.stock.send'))" orientation="center">{{ $t('stock.deliveryNote') }}</a-divider>
                        <a-button v-permission="'setting.stock.download'" type="primary" size="mini" :disabled="props.record.status_val != 2 && props.record.status_val != 4" style="margin-top:5px;width:130px" @click="handle('download',props.record)">{{ $t('base.download') }}</a-button>
                        <!-- <a-divider direction="vertical"></a-divider>
                        <a-button v-permission="'setting.stock.cancel'" type="primary" status="warning" size="mini" :disabled="props.record.status_val != 2" style="margin-top:5px;width:72px" @click="handle('delete',props.record)">{{ $t('base.delete') }}</a-button> -->
                        <a-divider v-permission="'setting.stock.download'" direction="vertical"></a-divider>
                        <a-button v-permission="'setting.stock.send'" type="primary" :status=" props.record.sendBtnText == t('invoice.reSend')? 'warning' : ''" size="mini" :disabled="(props.record.status_val != 2 && props.record.status_val != 4) || props.record.sendDisabled" style="margin-top:5px;width:130px" @click="handle('send',props.record)">{{ props.record.sendBtnText }}</a-button>
                    </template>
                </a-popover>
            </template>
        </Table>

        <a-modal 
            v-model:visible="visible" 
            :onBeforeOk="signforBeforeOk" 
            @ok="handleSignfor" 
            @cancel="handleCancel"
        >
            <template #title>{{ $t('stock.signFor') }}</template>
            <div style="text-align:center">
                {{ $t('stock.signForDate') }}：
                <a-date-picker 
                    style="width: 200px;" 
                    v-model="sign_for_date" 
                    :show-time="false"
                    :disabledDate="(current)=>setDisabledDate(current)"
                />
            </div>
        </a-modal>

        <a-modal 
            v-model:visible="editVisible" 
            :onBeforeOk="editBeforeOk" 
            @ok="saveEditStock" 
            @cancel="handleCancel"
        >
            <template #title>{{ $t('base.edit') }}</template>
            <div style="text-align:center">
                <Form 
                    :form="editForm"
                    @handleSelectChange="handleEditSelectChange"
                    @handleInput="handleInput"
                ></Form>
            </div>
        </a-modal>

        <a-modal 
            v-model:visible="sendZUEmailVisible" 
            :onBeforeOk="handleSendEmailToZU" 
        >
            <template #title>{{ $t('stock.sendEmailToZU') }}</template>
            <div style="text-align:center">
                <div style="margin:0 0 5px 110px;text-align:left;color:#1890ff;">{{ $t('base.tip') }}: {{ $t('stock.sendEmailToZUTip') }}</div>
                <div><span style="display:inline-block;width:60px;text-align:right;">{{ $t('base.email') }}：</span><a-input v-model="zuEmail" :style="{width:'320px'}" allow-clear /></div> 
                <div><span style="display:inline-block;width:60px;text-align:right;"> {{ $t('base.cc') }}：</span><a-input v-model="zuEmailCC" :style="{margin:'10px 0 0 0',width:'320px'}" allow-clear /></div>
            </div>
        </a-modal>

        <!--  详情 -->
        <Detail :row="rowData" :detailVisible="detailVisible" :type="0" @handleCancel="handleCancelDrawer"></Detail>
    
        <!-- 添加车架号 -->
        <a-modal 
            v-model:visible="addFrameNoVisible" 
            :onBeforeOk="handleAddFrameNo" 
        >
            <template #title>{{ $t('stock.addFrameNo') }}</template>
            <div style="text-align:center">
                <div v-for="(item,index) in canAddFrameList" :key="index" >
                    {{ item.label }}:
                    <a-input 
                        :style="{marginBottom:'10px',width:'320px'}"
                        v-model="item.value" 
                        :disabled="item.disabled"
                        allow-clear 
                    />
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, computed, toRefs, h } from 'vue';
    import { useRouter } from 'vue-router';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Detail from './Detail.vue';
    import { QueryForm, QueryForm2, EditForm } from './queryConfig/QueryForm.js';
    import { dateToTimestamp, timestampToDate, getNowDate, getTomorrowDate, formatterToPoint, formatterToComma, hasPermission, } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const { t } = useI18n()
    const router = useRouter()

    const localeStore = useLocale()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const visible = ref(false)
    const editVisible = ref(false)
    const detailVisible = ref(false)
    const addFrameNoVisible = ref(false)
    const customerInfo_loading = ref(false)
    const amountInfo_loading = ref(false)
    const showForm = ref(false)
    const customerInfo = ref({})
    const amountInfo = ref({})
    const sign_for_date = ref('')
    const rowData = ref(null)
    const queryForm = reactive(QueryForm)
    const warehouseData = ref([])
    // const queryForm2 = reactive(QueryForm2)
    const editForm = reactive(EditForm)
    const unoutboundCount = reactive({
        bom:0,
        bike:0,
    })
    const zuEmail = ref('')
    const zuEmailCC = ref('')
    const sendZUEmailVisible = ref(false)
    const warningDate = ref(getNowDate().split(' ')[0])
    const warningtimestamp = ref(dateToTimestamp(`${warningDate.value} 00:00:00`))
    const timezoneOffset = ref(new Date().getTimezoneOffset() / 60)  // 获取当前时区的偏移量 ， 偏移量=-8 ==> 北京时间   偏移量=-2 ==> 柏林时间
    const timeDiff = ref(6 * 60 * 60 * 1000) // 中国与德国时差
    const exporting = ref(false)
    const canAddFrameList = ref([])
    const is_hepha_customer = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'50',
                fixed:'left',
                align:'left',
            },
            {
                // title: '订单名称',
                title: t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'160',
                ellipsis:true,
                tooltip:true,  
                fixed:'left',
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'mes出库单号',
                title: t('stock.deliveryNumber'),
                dataIndex: 'delivery_number',
                key:'delivery_number',
                width:'220',
                ellipsis:true,
                tooltip:true,  
                // fixed:'left',
                align:'left',
            },
            {
                // title: '仓库',
                title: t('order.warehouse'),
                dataIndex: 'warehouse',
                key:'warehouse',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'sku',
                title: t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '出库状态',
                title: t('order.outboundStatus'),
                dataIndex: 'status',
                key:'status',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '产品名称',
                title: t('order.productName'),
                dataIndex: 'name',
                key:'name',
                width:'200',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: '车型/上市年份',
                title:t('stock.modelModelYear'),
                dataIndex: 'model_model_year',
                key:'model_model_year',
                width:'200',
                align:'left',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            // {
            //     // title: '车型',
            //     title:t('order.model'),
            //     dataIndex: 'model',
            //     key:'model',
            //     width:'120',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '上市年份',
            //     title:t('order.modelYear'),
            //     dataIndex: 'model_year',
            //     key:'model_year',
            //     width:'120',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '品牌名称',
                title:t('stock.brandPartName'),
                dataIndex: 'brand_part_name',
                key:'brand_part_name',
                width:'160',
                align:'left',
                ellipsis:true,
                tooltip:true,
                slotName:'slot'
            },
            // {
            //     // title: '品牌名称',
            //     title:t('order.brandName'),
            //     dataIndex: 'brand_name',
            //     key:'brand_name',
            //     width:'120',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '零件名称',
            //     title:t('order.partName'),
            //     dataIndex: 'part_name',
            //     key:'part_name',
            //     width:'120',
            //     align:'left',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '订单类型',
                title: t('order.orderChannelType'),
                dataIndex: 'order_channel_type',
                key:'order_channel_type',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '数量',
                title: t('stock.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '客户',
                title: t('order.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'230',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '出库时间',
                title: t('stock.outboundDate'),
                dataIndex: 'outbound_date',
                key:'outbound_date',
                width:'170',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            // {
            //     // title: '预计出库时间',
            //     title: t('stock.transactionDate'),
            //     dataIndex: 'transaction_date',
            //     key:'transaction_date',
            //     width:'170',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            // {
            //     // title: '实际出库时间',
            //     title: t('stock.deliveryDate'),
            //     dataIndex: 'delivery_date',
            //     key:'delivery_date',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            {
                // title: '物流信息',
                title: t('stock.logistics'),
                dataIndex: 'logistics',
                key:'logistics',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '运费',
                title: t('stock.cargoFreight'),
                dataIndex: 'cargo_freight',
                key:'cargo_freight',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '车架号',
                title: t('order.frameNumber'),
                dataIndex: 'frame_number',
                key:'frame_number',
                width:'250',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'PO号',
                title: t('stock.po'),
                dataIndex: 'po',
                key:'po',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: 'erp订单号',
                title: t('order.erpNo'),
                dataIndex: 'erp_no',
                key:'erp_no',
                width:'160',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                // title: 'erp物料号',
                title: t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '实际出库时间',
            //     title: t('stock.signTime'),
            //     dataIndex: 'sign_time',
            //     key:'sign_time',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            //     slotName:'slot'
            // },
            {
                // title: '创建人',
                title: t('order.createUser'),
                dataIndex: 'create_user',
                key:'create_user',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '备注',
                title: t('stock.remark'),
                dataIndex: 'instruction',
                key:'instruction',
                width:'270',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'110',
                align:'left',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:680,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
            
        },
    })

    const init=()=>{
        let item = queryForm.formField.find(i=> i.key == 'warehouse')
        item.allowClear = userInfo.role != '6' && userInfo.role != '7'
        if(userInfo.role == '6'){ // ZU客户
            queryForm.formData.warehouse_list = ['HF_OP01']
            getStockOutList()
        }if(userInfo.role == '7'){ // 新欧达
            queryForm.formData.warehouse_list = ['HFNORDFG01']
            getStockOutList()
        }else{ // hepha运营、hepha仓管
            getStockOutList()
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getStockOutList()
                break;
            case 'reset':
                if(userInfo.role != '6' && userInfo.role != '7'){ 
                    queryForm.formField.forEach(i=>{
                        if(i.key != 'warehouse'){
                            queryForm.formData[i.key] = ''
                        }else{
                            queryForm.formData['warehouse'] = ''
                            queryForm.formData['warehouse_list'] = []
                        }
                    })
                }else{ // ZU客户、新欧达
                    queryForm.formField.forEach(i=>{
                        if(i.key !== 'warehouse'){
                            queryForm.formData[i.key] = ''
                        }
                    })
                }
                table.value.configs.pagination.current = 1
                getStockOutList()
                break;
            case 'signFor':
                visible.value = true
                rowData.value = row
                break;
            case 'edit':
                editVisible.value = true
                rowData.value = row

                editForm.formField.forEach(i=>{
                    if(i.key == 'cargo_freight'){
                        editForm.formData[i.key] = row[i.key] == '-'? '' : formatterToComma(row[i.key].split('€')[1].trim(),timezoneOffset.value == '-8') // 非北京时间，则使用德国计数方式： 小数点 => 逗号
                    }else if(i.key == 'courier_status'){
                        editForm.formData[i.key] = row[i.key] != '3'? '' : row[i.key]
                    }else{
                        editForm.formData[i.key] = row[i.key] == '-'? '' : row[i.key]
                    }
                })
                editForm.formData.courier_id = ''

                let courier_type = editForm.formField.find(i=>i.key == 'courier_type')
                let courier_no = editForm.formField.find(i=>i.key == 'courier_no')
                let courier_url = editForm.formField.find(i=>i.key == 'courier_url')
                let courier_status = editForm.formField.find(i=>i.key == 'courier_status')

                let reg = /^[0-9]{8}$/g
                let bool = reg.test(editForm.formData.courier_no)
                courier_type.disabled = rowData.value.status_val == 2 && !!editForm.formData.courier_type && !!editForm.formData.courier_no
                courier_no.disabled = editForm.formData.courier_type === 'Cargoboard' && !bool? false : rowData.value.status_val == 2 && !!editForm.formData.courier_type && !!editForm.formData.courier_no
                courier_url.disabled = rowData.value.status_val == 2 && !!editForm.formData.courier_type && !!editForm.formData.courier_no
                courier_status.disabled = rowData.value.status_val == 1 || editForm.formData.courier_type === 'Cargoboard' || editForm.formData.courier_type === 'DHL'
                break;
            case 'cancelOutbound':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.cancelOutbopundConfirmTip') + `. ` + t('order.cancelConfirmTip'),
                    hideCancel:false,
                    width:500,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        cancelOutbound(row)
                    }
                });
                break;
            case 'exportFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        exportFile()
                    }
                });
                break;
            case 'separateExport':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        separateExport()
                    }
                });
                break;
            case 'zuExportFile':
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('stock.exportConfirmTip'),
                    hideCancel:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        zuExportFile()
                    }
                });
                break;
            case 'download':
                downloadDeliveryNote(row)
                break;
            case 'send':
                sendDeliveryNote(row)
                break;
            // case 'delete':
            //     Modal.warning({
            //         title: t('base.tip'),
            //         titleAlign:'start',
            //         content: t('base.deleteConfirmTip'),
            //         hideCancel:false,
            //         okText:t('base.ok'),
            //         cancelText:t('base.cancel'),
            //         onOk:()=>{
            //             deleteDeliveryNote(row)
            //         }
            //     });
            //     break;
            case 'detail':
                detailVisible.value = true
                rowData.value = row
                console.log(rowData.value,'detttttt')
                break;
            case 'sendEmailToZU':
                sendZUEmailVisible.value = true
                break;
            case 'addFrameNo':
                rowData.value = row
                addFrameNoVisible.value = true
                canAddFrameList.value = []
                let frame_number_arr = row.frame_number.filter(i=>{
                    if(i.VEHICLE_STATUS == 0) return i
                })
                for(let i=0; i<=row.quantity - 1; i++){
                    if(frame_number_arr.length > 0 && i <= frame_number_arr.length - 1){
                        canAddFrameList.value.push({
                            value:frame_number_arr[i].FRAME_NUMBER,
                            label:`${t('stock.frameNumber')} ${i + 1}`,
                            disabled:false,
                        })
                    }else{
                        canAddFrameList.value.push({
                            value:'',
                            label:`${t('stock.frameNumber')} ${i + 1}`,
                            disabled:false,
                        })
                    }
                }
                console.log(canAddFrameList.value,'canAddFrameList')
                break;
        }
    }

    const btnPopupVisibleChange = (val,row)=>{
        // console.log(val,row,'kkk')
        if(val && row.status_val == 2){
            vaildDeliveryNoteSendCount(row)
        }
    }

    const handleCancelDrawer = ()=>{
        detailVisible.value = false
    }

    // 导出出库单(FI)
    const exportFile = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'transaction_date' && i.key !== 'delivery_date'){
                if(i.key == 'warehouse'){
                    form['warehouse_list'] = queryForm.formData['warehouse_list']
                }else{
                    form[i.key] = queryForm.formData[i.key]
                }
            }
        })

        if(userInfo.role.split(',').includes('5') && userInfo.role != '6' && userInfo.role != '7' && queryForm.formData.warehouse_list.length == 0){
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options.forEach(i=>{
                form.warehouse_list.push(i.value)
            })
        }

        let param = {
            ...form,
            type:0,
            order_name:queryForm.formData.order_name.trim(),
            delivery_number: queryForm.formData.delivery_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            frame_number:queryForm.formData.frame_number.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            begin_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[0]} 00:00:00`),
            end_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[1]} 23:59:59`),
            begin_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[0]} 00:00:00`),
            end_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[1]} 23:59:59`),
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        let res = await StockOutApi.getInstance().exportFile(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('stock.exportShipmentData2')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            exporting.value = false
            Message.success(t('base.exportSuccess'))
        }else{
            Message.error(res.msg)
        }
    }

    // 导出出库单
    const separateExport = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'transaction_date' && i.key !== 'delivery_date'){
                if(i.key == 'warehouse'){
                    form['warehouse_list'] = queryForm.formData['warehouse_list']
                }else{
                    form[i.key] = queryForm.formData[i.key]
                }
            }
        })

        if(userInfo.role.split(',').includes('5') && userInfo.role != '6' && userInfo.role != '7' && queryForm.formData.warehouse_list.length == 0){
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options.forEach(i=>{
                form.warehouse_list.push(i.value)
            })
        }

        let param = {
            ...form,
            type:0,
            order_name:queryForm.formData.order_name.trim(),
            delivery_number: queryForm.formData.delivery_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            frame_number:queryForm.formData.frame_number.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            begin_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[0]} 00:00:00`),
            end_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[1]} 23:59:59`),
            begin_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[0]} 00:00:00`),
            end_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[1]} 23:59:59`),
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        let res = await StockOutApi.getInstance().separateExportFile(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('stock.exportShipmentData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            exporting.value = false
            Message.success(t('base.exportSuccess'))
        }else{
            Message.error(res.msg)
        }
    }

    // ZU 导出出库单
    const zuExportFile = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'transaction_date' && i.key !== 'delivery_date'){
                if(i.key == 'warehouse'){
                    form['warehouse_list'] = queryForm.formData['warehouse_list']
                }else{
                    form[i.key] = queryForm.formData[i.key]
                }
            }
        })

        let param = {
            ...form,
            type:0,
            order_name:queryForm.formData.order_name.trim(),
            delivery_number: queryForm.formData.delivery_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            frame_number:queryForm.formData.frame_number.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            begin_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[0]} 00:00:00`),
            end_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[1]} 23:59:59`),
            begin_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[0]} 00:00:00`),
            end_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[1]} 23:59:59`),
        }
        Message.success(t('base.exporting'))
        exporting.value = true
        let res = await StockOutApi.getInstance().zuExportFile(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('stock.exportShipmentData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            exporting.value = false
            Message.success(t('base.exportSuccess'))
        }else{
            Message.error(res.msg)
        }
    }

    // 发送出货邮件给ZU
    const handleSendEmailToZU = async()=>{
        if(!zuEmail.value){
            Message.error(t('base.email') + ' ' + t('base.noEmpty'))
            return false
        }
        let param = {
            date:getTomorrowDate(),
            user:zuEmail.value.replace('，',','),
            cc:zuEmailCC.value.replace('，',','),
        }
        console.log(param,'param')
        let res = await StockOutApi.getInstance().sendEmailToZU(param)
        if(res.code == 0){
            Message.success(t('base.sendSuccess'))
            sendZUEmailVisible.value = false
            zuEmail.value = ''
            zuEmailCC.value = ''
        }else{
            Message.error(res.msg)
        }
    }

    // 下载发货单
    const downloadDeliveryNote = async (row)=>{
        let param = {
            delivery_number: row.delivery_number,
        }
        table.value.configs.loading = true
        let res = await StockOutApi.getInstance().downloadDeliveryNote(param, encodeURIComponent(row.order_name))
        if(!res.code){
            let blob = new Blob([res],{type: 'application/octet-stream'})
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${row.order_name}.pdf`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            setTimeout(()=>{
                table.value.configs.loading = false
                Message.success(t('base.downloadSuccess'))
            },1500) 
        }else{
            Message.error(res.msg)
            table.value.configs.loading = false
        }
    }

    // 发送发货单
    const sendDeliveryNote = async (row)=>{
        console.log(row,encodeURIComponent(row.order_name))
        let param = {
            order_number:encodeURIComponent(row.order_name),
            delivery_number:row.delivery_number,
        }
        row.sendDisabled = true
        row.sendBtnText = t('base.sending')
        let res = await StockOutApi.getInstance().sendDeliveryNote(param)
        if(res.code == 0){
            Message.success(t('base.sendSuccess'))
            row.sendDisabled = false
            row.sendBtnText = t('base.send')
        }else{
            Message.error(res.msg)
        }
    }

    // 发送送货单次数校验
    const vaildDeliveryNoteSendCount = async (row)=>{
        let param = {
            simple_flag: 1,
            valid_flag:0,
            invoice_type:3,
            invoice_child_type: row.delivery_number
        }
        let res = await StockOutApi.getInstance().vaildDeliveryNoteSendCount(param)
        if(res.code == 0){
            row.sendBtnText = res.data.length == 0 || res.data[0].send_sequence === 0? t('base.send') : t('invoice.reSend') 
        }else{
            Message.error(res.msg)
        }
    }

    // 删除发货单
    // const deleteDeliveryNote = async (row)=>{
    //     let param = {
    //         order_number:row.order_name,
    //         invoice_type:3,
    //     }
    //     let res = await StockOutApi.getInstance().deleteDeliveryNote(param)
    //     if(res.code == 0){

    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const editCustomer = (customer_entity_id)=>{
        router.push({path:'/Customers/CustomerList', query:{customer_entity_id:customer_entity_id,fromPage:'Outbounds/StockOutList'}})
    }

    const handleSelectChange = (val,item,key)=>{
        // console.log(val,item,key, 'val,item,key')
        if(key == 'warehouse'){
            queryForm.formData.warehouse_list = !val? [] : [val]
        }
        table.value.configs.pagination.current = 1
        getStockOutList()
    }

    const handleEditSelectChange = (val,item,key)=>{
        // console.log(val,item,key, 'val,item,key')
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','Factory','SIMPLELOGISTIK','Raben']
        let courier_no_item = editForm.formField.find(i=> i.key == 'courier_no')
        if(key == 'courier_type'){
            courier_no_item.required = courierTypeArr.includes(val)
            editForm.formData.courier_no = editForm.formData.courier_type == 'Factory'? '000000' : ''
        }
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        table.value.configs.pagination.current = 1
        getStockOutList()
    }

    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getStockOutList()
    }

    const handleInput = (item,val)=>{
        if(item.key == 'courier_no'){
            let courier_no_item = editForm.formField.find(i=> i.key == 'courier_no')
            if(editForm.formData.courier_type === 'Cargoboard'){
                courier_no_item.maxLength = 8
                editForm.formData[item.key] = val.replace(/[^0-9]/g,'')
            }else{
                courier_no_item.maxLength = ''
                editForm.formData[item.key] = val.replace(/[^a-zA-Z0-9]/g,'')
            }
        }

        if(item.key == 'cargo_freight'){
            editForm.formData.cargo_freight = val.replace(/-/g, '')
        }
    }

    const handlePickerDateChange = (val,item)=>{
        // console.log(val,item,'iiiiii')
        table.value.configs.pagination.current = 1
        if(item.key == 'transaction_date'){
            queryForm.formData.begin_transaction_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.end_transaction_date = !val? '' : dateToTimestamp(val[1])
        }
        if(item.key == 'transaction_date'){
            queryForm.formData.begin_delivery_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.end_delivery_date = !val? '' : dateToTimestamp(val[1])
        }
        
        getStockOutList()
    }

    // 统计查询
    const handleCountSelectChange = (val,item,key)=>{}

    const handleCountPickerDateChange = (val,item)=>{
        // console.log(val,item,'iiiiii')
        if(item.key == 'transaction_date'){
            queryForm.formData.begin_transaction_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.end_transaction_date = !val? '' : dateToTimestamp(val[1])
        }
        if(item.key == 'transaction_date'){
            queryForm.formData.begin_delivery_date = !val? '' : dateToTimestamp(val[0])
            queryForm.formData.end_delivery_date = !val? '' : dateToTimestamp(val[1])
        }
    }


    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getStockOutList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getStockOutList()
    }

    const popupVisibleChange = (val,row)=>{
        if(val) getCustomer(row.customer_id)
    }  

    const popupVisibleChangeAmount = (val,row)=>{
        if(val) getAmount(row.order_id)
    }

    // 双击单元格
    const cellDblClick = (row,column)=>{
        // console.log(column,'col')
        if(column.key == 'instruction'){
            row.remarkIsText = false
        }
        // 暂时屏蔽
        // if(column.key == 'frame_number'){
        //     row.frameNumberIsText = false
        // }
    }

    const cancelSaveComment = (row)=>{
        row.remarkIsText = true
        getStockOutList()
    }

    // 取消出库单
    const cancelOutbound = async (row)=>{
        // console.log(row.order_type,'rowid')
        let param = {
            delivery_number: row.delivery_number,
            order_type: row.order_type
        }
        table.value.configs.loading = true
        let res = await StockOutApi.getInstance().cancelOutbound(param)
        if(res.code == 0){
            Message.success(t('base.cancelSuccess'))
            table.value.configs.loading = false
            getStockOutList()
        }else{
            Message.error(res.msg)
        }
    }

    // 添加、编辑车架号
    const handleAddFrameNo = async ()=>{
        for(let i=0; i<canAddFrameList.value.length; i++){
            let item = canAddFrameList.value[i]
            if(!item.value){
                Message.error(item.label+' '+t('base.noEmpty'))
                return false
            }

            // 兼容AG开头的旧车架号
            let reg = /^[A-Z0-9\-]{11,40}$/g
            let bool = reg.test(item.value)
            if(!bool){
                Message.error(item.label+' '+t('base.formatError'))
                return false
            }
        }

        let frame_number_arr = canAddFrameList.value.map(i=>{ return i.value })

        let param = {
            frame_number:frame_number_arr.join(',')
        }
        console.log(param,'pppp')
        let res = await StockOutApi.getInstance().editFrameNumber(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            getStockOutList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存车架号
    const saveFrameNumber = (row)=>{
        // console.log(row.frame_number_arr.join(','),row,'rrrrr')
        // if(row.frame_number_arr.length == 0){
        //     Message.error(t('stock.frameNumber')+' '+t('base.noEmpty'))
        //     return
        // }

        // for(let i=0;i<row.frame_number_arr.length;i++){
        //     let item = row.frame_number_arr[i].FRAME_NUMBER
        //     if(!item){
        //         Message.error(t('stock.frameNumber')+' '+t('base.noEmpty'))
        //         return
        //     }

        //     // let reg = /^LN[A-Z][0-9][A-Z]{2}[0-9]{6}$/g
        //     // let reg2 = /^AG\d{2}D\d{3}-\d{3}MY\d{9}[A-Z]$/g
        //     // let bool = reg.test(item)
        //     // let bool2 = reg2.test(item)
        //     // if(!bool && !bool2){
        //     //     Message.error(t('stock.frameNumber')+' '+t('base.formatError'))
        //     //     return
        //     // }

        //     // 兼容AG开头的旧车架号
        //     let reg = /^[A-Z0-9\-]{11,40}$/g
        //     let bool = reg.test(item)
        //     if(!bool){
        //         Message.error(t('stock.frameNumber')+' '+t('base.formatError'))
        //         return
        //     }
        // }

        // Modal.warning({
        //     title: t('base.tip'),
        //     titleAlign:'start',
        //     hideCancel:false,
        //     content: t('stock.confirmFrameNumber'),
        //     okText:t('base.ok'),
        //     cancelText:t('base.cancel'),
        //     onOk:async ()=>{
        //         let param = {
        //             frame_number:row.frame_number_arr.join(',')
        //         }
        //         let res = await StockOutApi.getInstance().editFrameNumber(param,row.id)
        //         if(res.code == 0){
        //             Message.success(t('base.saveSuccess'))
        //             getStockOutList()
        //         }else{
        //             Message.error(res.msg)
        //         }
        //     }
        // });
    }

    //  取消保存车架
    const cancelSaveFrameNumber = (row)=>{
        row.frameNumberIsText = true
        getStockOutList()
    }

    // 获取列表
    const getStockOutList = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'transaction_date' && i.key !== 'delivery_date' && i.key !== 'customer_id'){
                if(i.key == 'warehouse'){
                    form['warehouse_list'] = queryForm.formData['warehouse_list']
                }else{
                    form[i.key] = queryForm.formData[i.key]
                }
            }
        })

        if(userInfo.role.split(',').includes('5') && userInfo.role != '6' && userInfo.role != '7' && queryForm.formData.warehouse_list.length == 0){
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options.forEach(i=>{
                form.warehouse_list.push(i.value)
            })
        }

        let param = {
            ...form,
            type:0,
            order_name:queryForm.formData.order_name.trim(),
            delivery_number: queryForm.formData.delivery_number.toUpperCase().trim(),
            erp_no:queryForm.formData.erp_no.trim(),
            frame_number:queryForm.formData.frame_number.trim(),
            customer_entity_id:queryForm.formData.customer_id,
            begin_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[0]} 00:00:00`),
            end_transaction_date: !queryForm.formData.transaction_date? '' : dateToTimestamp(`${queryForm.formData.transaction_date[1]} 23:59:59`),
            begin_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[0]} 00:00:00`),
            end_delivery_date: !queryForm.formData.delivery_date? '' : dateToTimestamp(`${queryForm.formData.delivery_date[1]} 23:59:59`),
        }

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await StockOutApi.getInstance().getStockOutList(param, page_num, page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    status_val: item.status,
                    status: item.status == undefined? '-' : item.status == 1? t('order.unOutbound') : item.status == 2? t('order.outbound') : item.status == 3? t('stock.cancelOutbound2') : item.status == 4? t('stock.outScanned') : item.status == 7? t('order.uploading') : t('order.initial'),
                    erp_no: !item.erp_no? '-' : item.erp_no,
                    sku: item.sku == undefined? '-' : item.sku,
                    name: !item.product_map? '-' : item.product_map.english_name,
                    cargo_freight: item.cargo_freight == undefined? '-' : `€  ${formatterToComma(Number(item.cargo_freight),timezoneOffset.value == '-8')}`,
                    frame_number:item.frame_number == undefined? '-' : item.frame_number,
                    frame_number_arr: item.frame_number == undefined? [] : item.frame_number, //item.frame_number.map(i=>{return i}),
                    inventory_code: item.inventory_code == undefined? '-' : item.inventory_code,
                    courier_type:!item.courier_type? '-' : item.courier_type,
                    courier_no:!item.courier_no? '-' : item.courier_no,
                    courier_url:!item.courier_url? '-' : item.courier_url,
                    courier_status:!item.courier_status? '-' : item.courier_status,
                    delivery_date_val: item.delivery_date,
                    delivery_date: item.delivery_date == undefined? '-' : timestampToDate(item.delivery_date * 1000).split(' ')[0],
                    transaction_date: item.transaction_date == undefined? '-' : timestampToDate(item.transaction_date * 1000).split(' ')[0],
                    sign_time: item.sign_time == undefined? '-' : timestampToDate(item.sign_time * 1000).split(' ')[0],
                    create_date: !item.create_timestamp? '-' : timestampToDate(item.create_timestamp * 1000).split(' ')[0], 
                    remarkIsText:true,
                    frameNumberIsText:true,
                    instruction: item.instruction == undefined? '' : item.instruction,
                    create_user: !item.create_user? '-' : item.create_user,
                    order_channel_type_val: item.order_channel_type,
                    order_channel_type: item.order_channel_type == 0? t('order.user') : item.order_channel_type == 1? t('order.dealer') : item.order_channel_type == 2? t('order.ECommerceVendor') : item.order_channel_type == 5? t('order.c2c') : t('order.service'),
                    sendBtnText: t('base.send'),
                    model: item.product_map == undefined ? '-' : item.product_map.model == undefined? '-' : item.product_map.model,
                    model_year: item.product_map == undefined ? '-' : item.product_map.model_year == undefined? '-' : item.product_map.model_year,
                    brand_name: item.product_map == undefined ? '-' : item.product_map.brand_name == undefined? '-' :  item.product_map.brand_name,
                    part_name: item.product_map == undefined ? '-' : item.product_map.part_name == undefined? '-' :  item.product_map.part_name,
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.pagination.current = res.data.current
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 签收校验
    const signforBeforeOk = ()=>{
        // console.log(sign_for_date.value,'sign_for_date.value')
        if(!sign_for_date.value){
            Message.error(t('stock.signTime')+' '+t('base.noEmpty'))
            return false
        }

        return true
    }

    // 签收
    const handleSignfor = async()=>{
        let param = {
            order_line_ids: rowData.value.order_line_id,
            sign_time: dateToTimestamp(sign_for_date.value),
        }
        // console.log(param,'ppp')
        let res = await StockOutApi.getInstance().signFor(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('stock.signForSuccess'))
            getStockOutList()
        }else{
            Message.error(res.msg)
        }
    }

    // 签收日期限制
    const setDisabledDate = (current)=>{
        if(visible.value){
            console.log(current,'cur')
            let currentDate = getNowDate() // 当前日期
            let currentDateTimestamp = dateToTimestamp(currentDate) // 当前日期时间戳
            let everyDate = timestampToDate(new Date(current).getTime()).split(' ')[0] // 日期组件-每天日期
            let everyDateTimestamp = dateToTimestamp(everyDate) // 日期组件-每天日期时间戳
            return currentDateTimestamp < everyDateTimestamp || everyDateTimestamp < rowData.value.delivery_date_val
        }
    }

    // 编辑校验
    const editBeforeOk = ()=>{
        let courierTypeArr = ['Cargoboard','DHL','ZUFALL','Factory','SIMPLELOGISTIK','Raben']
        let formData = editForm.formData
        if(!formData.courier_type && !formData.courier_no && !formData.courier_url && !formData.cargo_freight){
            Message.error(t('stock.contentTip'))
            return false
        }else if(courierTypeArr.includes(formData.courier_type) && !formData.courier_no){
            Message.error(t('order.courierNo')+' '+t('base.noEmpty'))
            return false
        }

        return true
    }

    // 编辑出库信息
    const saveEditStock = async()=>{
        if(
            (!!editForm.formData.courier_type && !!editForm.formData.courier_no) || 
            (!!editForm.formData.courier_type && !!editForm.formData.courier_url && editForm.formData.courier_type !== 'Cargoboard' && editForm.formData.courier_type !== 'DHL')
        ){
            await getCourierId()
        }

        let param = {}
        editForm.formField.forEach(i=>{
            if(i.key == 'cargo_freight'){
                param[i.key] = editForm.formData[i.key] == undefined? '' : formatterToPoint(editForm.formData[i.key], )
            }else{
                if(editForm.formData[i.key] !== ''){
                    param[i.key] = !editForm.formData[i.key]? '' : editForm.formData[i.key]
                }
            }
        })
        if(editForm.formData.courier_id) param.courier_id = editForm.formData.courier_id
        // console.log(param,'ppp')
        let res = await StockOutApi.getInstance().editStock(param,rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            getStockOutList()
        }else{
            Message.error(res.msg)
        }
    }

    // 保存备注
    const saveComment = async (row)=>{
        let param = {
            instruction:row.instruction,
        }
        let res = await StockOutApi.getInstance().saveComment(row.id,param)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            row.remarkIsText = true
            getStockOutList()
        }else{
            Message.error(res.msg)
        }
    }

    
    // 获取下出库单整车数量
    // const getBikeCount = async ()=>{
    //     let param = {
    //         category:'627.501',
    //     }
    //     let res = await StockOutApi.getInstance().getBikeCount(param)
    //     if(res.code == 0){
    //        dataCount.bikeCount = res.data
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    // 获取订单金额
    const getAmount = async (order_id)=>{
        amountInfo_loading.value = true
        let res = await StockOutApi.getInstance().getAmount(order_id)
        if(res.code == 0){
            amountInfo.value = {
                order_name: res.data.order_name,
                order_amount: res.data.order_amount == undefined || res.data.order_amount === ''? '-' : '€ ' + Number(res.data.order_amount).toFixed(2),
                pay_amount: res.data.pay_amount == undefined || res.data.pay_amount === ''? '-' : '€ ' + Number(res.data.pay_amount).toFixed(2),
                real_pay_amount: res.data.real_pay_amount == undefined || res.data.real_pay_amount === ''? '-' : '€ ' + Number(res.data.real_pay_amount).toFixed(2),
                order_discount: res.data.order_discount == undefined || res.data.order_discount === ''? '-' : '€ ' + Number(res.data.order_discount).toFixed(2),
                refund_amount: res.data.refund_amount == undefined || res.data.refund_amount === ''? '-' : '€ ' + Number(res.data.refund_amount).toFixed(2),
                order_tax: res.data.order_tax == undefined || res.data.order_tax === ''? '-' : '€ ' + Number(res.data.order_tax).toFixed(2),
                tax_rate: res.data.tax_rate == undefined || res.data.tax_rate === ''? '-' : res.data.tax_rate * 100 + '%',
            }
            amountInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取用户信息 
    const getCustomer = async (customer_id)=>{
        customerInfo_loading.value = true
        let res = await StockOutApi.getInstance().getCustomer(customer_id)
        if(res.code == 0){
            customerInfo.value = {
                ...res.data,
                sex:res.sex == 0? t('customer.male') : t('customer.female'),
                countryCity: !res.data.city? `${res.data.country} / -` : `${res.data.country} / ${res.data.city}`
            }
            customerInfo_loading.value = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库描述
    const getWarehouseDescription = (val,row)=>{
        row.warehouse_description = warehouseData.value.find(i=>i.subinventory_name == row.warehouse).description
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await StockOutApi.getInstance().getWarehouse()
        if(res.code == 0){
            warehouseData.value = res.data
            let item = queryForm.formField.find(i=> i.key == 'warehouse')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(userInfo.role != '6' && userInfo.role != '7' && !userInfo.role.split(',').includes('5')){ // Hepha运营
                    item.options.push({
                        label: i.description,
                        value: i.subinventory_name,
                    })
                }else if(userInfo.role.split(',').includes('5') && i.subinventory_name != 'HF_OP01' && i.subinventory_name != 'HF_OP02'){ // Hepha仓管
                    item.options.push({
                        label: i.description,
                        value: i.subinventory_name,
                    })
                }else if(userInfo.role == '6' && (i.subinventory_name == 'HF_OP01' || i.subinventory_name == 'HF_OP02')){ // ZU用户
                    item.options.push({
                        label: i.description,
                        value: i.subinventory_name,
                    })
                }else if(userInfo.role == '7' && i.subinventory_name == 'HFNORDFG01'){ // 新欧达
                    item.options.push({
                        label: i.description,
                        value: i.subinventory_name,
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await StockOutApi.getInstance().getCourierType({dict_code: "courier"})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'courier_type')
            let item2 = editForm.formField.find(i=> i.key == 'courier_type')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
                item2.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: editForm.formData.courier_type,
            courier_no: editForm.formData.courier_no,
            courier_url: editForm.formData.courier_url,
            courier_status: editForm.formData.courier_status,
        }
        let res = await StockOutApi.getInstance().getCourierId(param)
        if(res.code == 0){
            editForm.formData.courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU下拉数据
    const getProductList = async ()=>{
        let res = await StockOutApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=>i.key == 'sku')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取客户名称
    const getCustomerList = async ()=>{
        let res = await StockOutApi.getInstance().getCustomerList({simple_flag:1})
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'customer_id')
            item.options= []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    // label: i.name_show,
                    label: i.name,
                    value: i.id, 
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取创建人
    const getUser = async()=>{
        let res = await StockOutApi.getInstance().getUser()
        if(res.code == 0){
            const item = queryForm.formField.find(i=> i.key == 'create_by')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.user_name,
                    value: i.id,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    
    // 获取未出库的整车和bom数量
    const getUnoutboundBikeBomCount = async()=>{
        let param = {
            timestamp: warningtimestamp.value
        }
        let res = await StockOutApi.getInstance().getUnoutboundBikeBomCount(param)
        if(res.code == 0){
            unoutboundCount.bike = res.data.bike || 0
            unoutboundCount.bom = res.data.bom || 0
        }else{
            Message.error(res.msg)
        }
    }

     // 获取bom类别
    //  const getBomCategory = async ()=>{
    //     let res = await StockOutApi.getInstance().getBomCategory()
    //     if(res.code == 0){
    //         let item = queryForm.formField.find(i=> i.key == 'category_code')
    //         item.options = []
    //         res.data.forEach(i=>{
    //             if(i.CATEGORY_CODE !== undefined && i.CATEGORY_CODE !== '627.501' && i.CATEGORY_CODE !== '627.502'){
    //                 item.options.push({
    //                     label: `${i.CATEGORY_CODE} | ${i.CATEGORY_NAME}`,
    //                     value: i.CATEGORY_CODE
    //                 })
    //             }
    //         })
    //     }else{
    //         Message.error(res.msg)
    //     }
    // }

    const getBomCategory = async ()=>{
        let param = {
            dict_code:'system',
            dict_sub_code:'product_category'
        }
        let res = await StockOutApi.getInstance().getCategory(param)
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'category_code')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value
                })
            })
        }else{
            Message.error(res.msg)
        }
    }


    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 45
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 130
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    watch(()=>editForm.formData.courier_type,(val)=>{
            // console.log(val,'vvbb')
            let item = editForm.formField.find(i=> i.key == 'courier_status')
            item.disabled = rowData.value.status_val == 1 || (rowData.value.status_val == 2 && (val == 'Cargoboard' || val == 'DHL'))
            if(val == 'Cargoboard' || val == 'DHL'){
                editForm.formData.courier_status = ''
            }
        },
        { deep:true }
    )

    onMounted(async ()=>{
        await getWarehouse()
        init()
        getCourierType()
        getProductList()
        getCustomerList()
        getUser()
        getUnoutboundBikeBomCount()
        getBomCategory()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        is_hepha_customer.value = userInfo.role == 16 || userInfo.id == 63

    })



</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:10;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }

        /deep/ .arco-form-item-layout-inline{
            margin-right: 0px;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_form2{
        flex:8;
    }
    .queryPanel_btn{
        display: flex;
        // flex-direction: column;
        // flex-wrap:wrap;
        flex: 1;
        align-items: center;
        justify-content: center;
        border-left:1px solid #eee;
        padding-left:10px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    .queryPanel_btn2{
        flex: 1;
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

.unoutboundCount{
    margin-bottom: 7px;
    padding: 5px 24px 5px;
    background: #fff;
    font-size: 12px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
    margin-top: 2px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 3px 0;
    font-size:13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}


/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.logisticsInfo{
    font-size: 12px;
    color: #666;
    // text-align: left;
}

.customer_info{
    font-size:12px;
    color: #666;
    padding: 0 10px;
    line-height: 18px;
}

/deep/ .arco-tabs-nav-type-line .arco-tabs-tab{
    padding:3px 0;
}

.remark_content{
    display:inline-block;
    width:180px;
    line-height:11px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    cursor: pointer;
}

.remark{
    padding: 3px;
    background: #f5f5f5;
    cursor: pointer;
}

.frameNumber{
    display: flex;
    padding: 3px;
    // cursor: pointer;

    .frameNumberDiv{
        display: flex;
        flex: 1;
        .frameNumberTextParent{
            display: inline-block;

            .frameNumberText{
                margin-top: 3px;
                width: 140px;
                font-size: 12px;
                // background: #f5f5f5;
            }
        }
        .frameNumberInput{
            display: inline-block;
        }
    }

    .iconBtn{
        display: flex;
        flex: 1;
        align-items: center;
        .icon{
            display:block;
            margin-left:10px;
            margin:8px;
            cursor:pointer;
            font-weight:blod;
        }
    }   
}

.edit_icon{
    float:right;
    color: #4080ff;
    cursor:pointer;
}

.unoutboundCount{
    color: #165dff;
    font-weight: 600;

    .countBar{
        display: inline-block;
        width: fit-content;
        font-size:12px;
        font-weight: 600;
    }

    /deep/ .arco-alert{
        padding: 1px 15px;
        vertical-align: bottom;

        .arco-alert-icon,
        .arco-alert-body{
            display: inline-block;
        }
    }
}

/deep/ .arco-divider-text-center{
    font-weight: bold;
}

/deep/ .arco-popover-popup-content{
    padding: 8px 16px;
}
</style>